import { createContext, useContext } from 'react';
import type { ChatMention } from '@trinity/chat';

export type FetchSubjectSuggestionsResult = {
  results: Array<{
    entityId: string | number;
    objectId?: string | number;
    name: string;
    type: string;
    link?: string;
    subtitle?: string;
  }>;
};

export type FetchSubjectSuggestionsPagination = {
  limit: number;
  offset: number;
};

export type AtMentionDisplayConfig = {
  headerLabel?: string;
  inputPlaceholder?: string;
  primaryFieldKey?: string;
  subtitleFieldKey?: string;
};

export type AtMentionContextValue = [
  contextIdentifier: string,
  fetchSubjectSuggestions: (
    query: string,
    pagination?: FetchSubjectSuggestionsPagination
  ) => Promise<FetchSubjectSuggestionsResult>,
  displayConfig?: AtMentionDisplayConfig,
];

export const AtMentionContext = createContext<AtMentionContextValue | null>(null);

export function useAtMentionContext(): AtMentionContextValue {
  const value = useContext(AtMentionContext);
  if (!value) {
    throw new Error('useAtMentionContext must be used within an AtMentionContext.Provider');
  }
  return value;
}

export type AtMentionItem = Pick<ChatMention, 'entityId' | 'name' | 'type'> & {
  link?: string;
  subtitle?: string;
};
